/**
 * Whether there may be a session worth asking the API about.
 *
 * The session cookie is HttpOnly, so no page can see it. The backend sets a
 * second one, `signed_in`, on every signed-in answer and clears it on the
 * first answer that finds no session (SignedInCookieListener). It proves
 * nothing — the session does — but its absence means there is nothing to ask,
 * so a visitor who never signed in is spared a request that could only
 * answer 401.
 */
export function mayBeSignedIn() {
  return document.cookie.split(';').some((pair) => pair.trim().startsWith('signed_in='));
}
